<ecp-hero title="Bulk Order Status" image="assets/images/headers/experts.jpg"> </ecp-hero>

<div class="container bulk-order-status-page">
  <div class="col s12 is-flex is-fullwidth">
    <div class="mt-50">
      <ng-container *ngIf="!isView; else showDetails">
        <ecp-bulk-order-list [orderData]="bulkOrderData" (orderDetails)="viewDetails($event)"></ecp-bulk-order-list
      ></ng-container>
      <ng-template #showDetails>
        <div class="row">
          <mat-card class="mat-card">
            <div class="row">
              <div class="col s2"><button (click)="isView = false" class="btn btn-primary">Back to List</button></div>
            </div>
            <div class="mt-50">
              <ecp-bulk-order-details
                [viewUploadedData]="orderViewData"
              ></ecp-bulk-order-details>
            </div>
          </mat-card>
        </div>
      </ng-template>
    </div>
  </div>
</div>
